import { DecimalPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ChargersService } from '../chargers/chargers.service';
import { ChargerOverview } from '../models';

@Component({
	selector: 'app-dashboard',
	imports: [MatCardModule, MatProgressSpinnerModule, DecimalPipe],
	templateUrl: './dashboard.component.html',
	styleUrl: './dashboard.component.scss'
})
export class DashboardComponent {
	chargers: ChargerOverview[] | null = null
	chargersLoaded: boolean = false;
	chargersCount: number = 0;
	chargersOnline: number = 0;
	chargersPower: number = 0;
	chargersUpdate: number = 0;
	chargersVehicleConnected: number = 0;
	chargersCharging: number = 0;

	private chargersService = inject(ChargersService);
	
	ngOnInit(): void {
		this.retrieveChargers();
	}

	async retrieveChargers() {
		this.chargersService.getChargersOverview().subscribe((chargers) => {
			console.log('retrieveChargers():', chargers);
			this.chargers = chargers;
			this.chargersCount = this.chargers.length;
			this.chargersOnline = 0;
			this.chargersUpdate = 0;
			this.chargersVehicleConnected = 0;
			this.chargersCharging = 0;
			this.chargersPower = 0;
			for (const charger of this.chargers) {
				if (charger.cloudConnectionState === 'Online') {
					this.chargersOnline++;
				}
				if (charger.chargerFirmwareStatus.isFirmwareUpdateAvailable) {
					this.chargersUpdate++; 
				}
				if (charger.chargerStatus.indicators.isVehicleConnected) {
					this.chargersVehicleConnected++;
				}
				if (charger.chargeSessionStatus.actualChargingPower) {
					this.chargersCharging++;
					this.chargersPower = this.chargersPower + charger.chargeSessionStatus.actualChargingPower;
				}
			}
			this.chargersLoaded = true;
		});
	}
}
